import { useQuery } from "@tanstack/react-query";
import { FIVE_MINUTES_IN_MS } from "../configuration/globalConstants";
import { getSubtypes } from "../services/mapServices";
import { useState } from "react";

export function useSectionSubtypes() {
  const [params, setParams] = useState({ type: null, fatherValue: null });
  const subtypes = useQuery({
    queryKey: ["sectionSubtypes", params],
    queryFn: () => getSubtypes(params.type, params.fatherValue),
    enabled: !!params.type && !!params.fatherValue,
    staleTime: FIVE_MINUTES_IN_MS,
    
  });
  const getSubtypesOptions = (type, fatherValue) => {
    if (type && fatherValue) {
      setParams({ type, fatherValue });
    }
  };

  return {
    sectionSubtypesOptions: subtypes.data || [],
    isLoadingSectionSubtypes: subtypes.isLoading,
    getSubtypesOptions,
  };
}
